"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpCodeUsagesWithPaginationSchema = exports.FeatureExpEnvironmentCodeUsageSchema = exports.FeatureExpCodeUsageSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
exports.FeatureExpCodeUsageSchema = zod_1.z.object({
    flag_key: zod_1.z.string(),
    repository_url: zod_1.z.string(),
    file_path: zod_1.z.string(),
    repository_branch: zod_1.z.string(),
    line_number: zod_1.z.number(),
    code: zod_1.z.string(),
    code_line_highlight: zod_1.z.number(),
    id: zod_1.z.string(),
});
exports.FeatureExpEnvironmentCodeUsageSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.array(exports.FeatureExpCodeUsageSchema));
exports.FeatureExpCodeUsagesWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: exports.FeatureExpEnvironmentCodeUsageSchema,
});
//# sourceMappingURL=schemas.js.map